/**
 * @file contract.ts
 * @description 电量、充电状态与续航时间查询契约。
 */

import { FeatureBase } from '../FeatureBase'

/** 设备返回的电量快照。 */
export interface BatteryStatus {
  /** 电量百分比，0-100 */
  level: number
  /** 是否正在充电 */
  charging: boolean
}

/** 设备返回的续航时间（小时）。 */
export interface BatteryRuntime {
  /** 最低续航时间（小时） */
  min: number
  /** 最高续航时间（小时） */
  max: number
}

// 扩展功能注册表
declare module '../FeatureMap' {
  export interface DeviceFeatureMap {
    battery: IBatteryFeature
  }
}

export interface IBatteryFeature {
  /** 显式查询当前电量与充电状态 */
  getBatteryStatus(): Promise<BatteryStatus>
  /** 显式查询最低/最高续航时间（小时）；未实现的芯片抛 `NOT_SUPPORTED` */
  getBatteryRuntime(): Promise<BatteryRuntime>
}

export class BatteryFeature extends FeatureBase implements IBatteryFeature {
  /** 显式查询当前电量与充电状态 */
  getBatteryStatus(): Promise<BatteryStatus> {
    return this.unsupported('BatteryFeature.getBatteryStatus')
  }

  getBatteryRuntime(): Promise<BatteryRuntime> {
    return this.unsupported('BatteryFeature.getBatteryRuntime')
  }
}
